<template>
  <div>
    <base-instance-selection
      :headerInfo="headerInfo"
      :buttonText="buttonText"
      :headers="headers"
      :rows="getSuperRowsData"
      :loanCategories="superCategories"
      @compare="compareSelectedSuperannuations"
      @createNew="createNewSuperannuation"
      @rowSelected="onSelectedSuperannuation"
      @duplicateRow="duplicateRow"
      @renameRow="renameRow"
      @deleteRow="deleteRow"
      :actionButtonText="actionButtonText"
      :imagepath="imagepath"
    >
    </base-instance-selection>
    <confirmation-dialog
      v-for="dialog in confirmationDialogList"
      :key="dialog.id"
      :dialog="dialog"
      @buttonclick="genericMethodClick"
    >
      <template #dialogBody v-if="!userInputText.isHide">
        <mds-input
          autocomplete="off"
          :label="''"
          v-model="userInputText.value"
          :error="userInputText.isError"
          :errorText="userInputText.errorText"
          :maxlength="maxValue"
        ></mds-input>
        <span>{{ userEnterCharCount }}/{{ maxValue }}</span></template
      >
    </confirmation-dialog>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { BaseInstanceSelection } from "../../component/loanSelection";
import { ConfirmationDialog } from "../../component/tool";
import MdsInput from "@mds/input";
import { DialogAction, EntityTypes } from "../../helpers/constant";
import Superannuation from "../../models/superannuation";
import { SuperannuationService } from "../../services";
import { CommonHelper } from "../../helpers";
import _ from "lodash";
import {
  SET_SUPERANNUATION_INFORMATION,
  GET_AUTH_INFORMATION,
  GET_CLIENT_INFORMATION,
  GET_SUPERANNUATION_INFORMATION,
  SET_SELECTED_SUPERANNUATION_INFORMATION,
  SET_SUPERANNUATION_DEFAULT_MODEL,
  SET_LOADER_VISIBILITY,
  SET_NOTIFICATION_SUMMARY,
  SET_ALL_SUPERANNUATION_INFORMATION,
  SET_COMPARE_SUPERANNUATIONS_INFO,
} from "../../helpers/vuex-constants";
import {
  SuperSelected,
  CompareAction,
  tabCreatedAction,
  tabSelectedAction,
  DuplicateAction,
  RenameAction,
  DeleteAction,
} from "../../helpers/userEvent";
import { ToolSelection, UserEvent } from "../../mixin";
export default {
  name: "superannuation-instance-Selection",
  components: {
    BaseInstanceSelection,
    ConfirmationDialog,
    MdsInput,
  },
  mixins: [ToolSelection, UserEvent],
  data() {
    return {
      headerInfo: {
        heading:
          "Select existing or create new instance from the engagement tools",
        headingIconText: "Click action button for other options",
        subHeading: "Select checkbox to start compare instances",
      },
      buttonText: "Create New Instance",
      actionButtonText: "Action",
      maxValue: 60,
      userInputText: {
        value: "",
        isError: false,
        errorText: [],
        isHide: false,
        id: 0,
        payload: {},
      },
      headers: [
        {
          fieldType: "checkbox",
          fieldName: "isSelected",
          style: { width: "45px" },
        },
        {
          text: "Instance Name",
          fieldType: "metadata",
          fieldDescription: "description",
          split: " ",
          metadata: [
            {
              heading: "Balance",
              key: "amount",
            },
            {
              heading: "Taxable",
              key: "taxable",
            },
            {
              heading: "Tax-free",
              key: "nonTaxable",
            },
          ],

          styleRow: { "padding-left": "4px" },
        },
        {
          text: "",
          fieldType: "tag",
          fieldAmount: "",
          fieldText: "",
          fieldDescription: "",
          style: { width: "90px" },
          styleRow: { "text-align": "center", "vertical-align": "middle" },
        },
        {
          text: "",
          fieldType: "profile",
          fieldAmount: "",
          fieldText: "",
          fieldDescription: "",
          style: { width: "70px" },
          styleRow: { "text-align": "center", "vertical-align": "middle" },
        },
        {
          text: "Last Modified",
          fieldType: "date",
          fieldAmount: "",
          fieldText: "text",
          fieldDescription: "",
          fieldName: "date",
          align: "right",
          sortable: true,
          sorted: 1,
          style: { width: "100px" },
          styleRow: { "vertical-align": "middle" },
        },
        {
          text: "",
          fieldType: "action",
          fieldAmount: "",
          fieldText: "text",
          fieldDescription: "",
          style: { opacity: "0px", width: "100px" },
          styleRow: { "text-align": "center", "vertical-align": "middle" },
        },
      ],
      rows: {
        type: Array,
      },
      selectedValue: "",
      confirmationDialogList: [
        {
          toggle: false,
          id: 1,
          title: "Discard Changes",
          rightButtons: [
            {
              text: "Cancel",
              variation: "secondary",
              emitevent: "cancel_Click",
              id: 1,
            },
            {
              text: "Save",
              variation: "primary",
              emitevent: "submit_Click",
              id: 3,
            },
          ],
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      setSuperannuationInformation: SET_SUPERANNUATION_INFORMATION,
      setNotificationSummary: SET_NOTIFICATION_SUMMARY,
      setLoaderVisibility: SET_LOADER_VISIBILITY,
    }),
    ...mapActions("superannuation", {
      setSelectedSuperannuationInfo: SET_SELECTED_SUPERANNUATION_INFORMATION,
      setSuperannuationDefaultModel: SET_SUPERANNUATION_DEFAULT_MODEL,
      setAllSuperannuationInformation: SET_ALL_SUPERANNUATION_INFORMATION,
      setCompareSuperannuationInfo: SET_COMPARE_SUPERANNUATIONS_INFO,
    }),

    async mapData() {
      let clid = this.getAuthInformation.encClientId;
      let advId = this.getAuthInformation.encAdviserId;
      this.setLoaderVisibility(true);
      let superannuationapiParams = {
        clientId: clid,
        adviserId: advId,
      };
      let setSuperannuationInfo = this.setSuperannuationInformation(
        superannuationapiParams
      );
      await setSuperannuationInfo;
      this.setLoaderVisibility(false);
      this.removeEmptySuperannuationInfo();
      let parentClientInfo = this.clientInformation.findIndex(
        (sr) => sr.entityType == EntityTypes.client
      );
      let partnerClientInfo = this.clientInformation.findIndex(
        (sr) => sr.entityType == EntityTypes.partner
      );
      // Mapping data properties
      let arr = this.getSuperannuationInformation.map((r) => {
        let p = {},
          totalSuperBalance = {};
        p.superAdvanceDetails = r.superAdvanceDetails;
        totalSuperBalance = p.superAdvanceDetails;
        let clientInfo = this.clientInformation.filter((item) => {
          return (
            item.clientId ==
            (r.ownerDetails.length == 0 || r.ownerDetails[0].clientId == 0
              ? r.clientId
              : r.ownerDetails[0].clientId)
          );
        });
        if (clientInfo.length == 0) {
          clientInfo = this.clientInformation.filter((item) => {
            return item.clientId == r.clientId;
          });
        }
        let partnerIndex = this.clientInformation.findIndex(
          (m) => m.entityType == EntityTypes.partner
        );
        let partnerInfo =
          partnerIndex > 0 ? this.clientInformation[partnerIndex].clientId : 0;
        let isClientExist = totalSuperBalance.filter(
          (x) => x.clientId == clientInfo[0].clientId
        );
        let isPartnerExist = totalSuperBalance.filter(
          (x) => x.clientId == partnerInfo
        );
        if (isClientExist.length > 0 && isPartnerExist.length > 0)
          p.ownerEntityType = 6;
        else if (isPartnerExist.length > 0) p.ownerEntityType = 2;
        else p.ownerEntityType = 1;
        p.clientName =
          clientInfo && clientInfo.length > 0 ? clientInfo[0].clientName : "";
        p.clientId = r.clientId;
        p.superFundId = r.superFundId;
        p.superFundGuid = r.superFundGuid;
        p.description =
          r.description == null ? "Superannuation" : r.description;
        p.otherDetail = r.otherDetail;
        p.fundDetails = r.fundDetails;
        p.nonSuperData = r.nonSuperData;
        p.s3FilePath = r.s3FilePath;
        p.ownerDetails = r.ownerDetails;
        p.isFromFact = r.isFromFact ? "FactFind" : "";
        p.profiles = this.getProfileName(
          p.ownerEntityType,
          p.clientName,
          partnerClientInfo,
          parentClientInfo
        );
        p.tagName = "";
        p.entityName = r.clientName;
        p.date = r.date;
        p.name = r.name;
        p.superAddtionalDetails = r.superAddtionalDetails;
        let totalAmount = totalSuperBalance.reduce(
          (acc, totalSuperBalance) => acc + totalSuperBalance.superFundBalance,
          0
        );
        p.amount = CommonHelper.convertIntoCurrencyWithoutDecimal(totalAmount);
        const taxableComponent = totalSuperBalance.reduce(
          (acc, component) => acc + component.taxableComponent,
          0
        );
        const taxFreeComponent = totalSuperBalance.reduce(
          (acc, component) => acc + component.taxFreeComponent,
          0
        );
        p.taxable =
          CommonHelper.convertIntoCurrencyWithoutDecimal(taxableComponent);
        p.nonTaxable =
          CommonHelper.convertIntoCurrencyWithoutDecimal(taxFreeComponent);

        p.actionButtons = this.getActionButton(r.isFromFact);
        let actualDate = r.modifiedDate
          ? r.modifiedDate.slice(0, 10)
          : new Date().toISOString().slice(0, 10);
        let currentDate = new Date().toISOString().slice(0, 10);
        p.date =
          CommonHelper.formatDate(actualDate) ==
          CommonHelper.formatDate(currentDate)
            ? "Today"
            : CommonHelper.formatDate(actualDate);
        if (p.superAddtionalDetails && p.superAddtionalDetails.length > 0) {
          p.superAddtionalDetails.map((r) => {
            let p = {};
            p.startDate = CommonHelper.convertDateToMonthYear(r.startDate);
            p.endDate = CommonHelper.convertDateToMonthYear(r.endDate);
            return p;
          });
        }
        return p;
      });
      this.rows = arr;
    },

    // Action Buttons
    getActionButton(isExisting) {
      let actionButtons = [];
      actionButtons.push({
        emitevent: "duplicateRow",
        icon: "group",
        text: "Duplicate",
        id: 1,
      });
      if (!isExisting) {
        actionButtons.push({
          emitevent: "renameRow",
          icon: "pencil",
          text: "Rename",
          id: 2,
        });
        actionButtons.push({
          emitevent: "deleteRow",
          icon: "trash",
          text: "Delete",
          id: 3,
        });
      }
      return actionButtons;
    },
    duplicateRow(data) {
      this.resetDialogField();
      this.userInputText.isHide = false;
      this.userInputText.id = DialogAction.Duplicate;
      this.userInputText.payload = data;
      if (data.description.length >= this.maxValue)
        this.userInputText.value =
          "Copy of " + data.description.substring(0, this.maxValue - 8) + "...";
      else this.userInputText.value = "Copy of " + data.description;
      this.confirmationDialogList[0].title =
        "Duplicate " +
        data.description.replaceAll("<", "&lt;").replaceAll(">", "&gt;");
      this.confirmationDialogList[0].toggle = true;
      this.confirmationDialogList[0].rightButtons[1].text = "Duplicate";
    },
    resetDialogField() {
      this.userInputText = {
        value: "",
        isError: false,
        errorText: [],
        isHide: false,
        id: 0,
      };
    },
    renameRow(data) {
      this.resetDialogField();
      this.userInputText.isHide = false;
      this.userInputText.id = DialogAction.Rename;
      this.userInputText.payload = data;
      this.confirmationDialogList[0].title =
        "Rename " +
        data.description.replaceAll("<", "&lt;").replaceAll(">", "&gt;");
      this.confirmationDialogList[0].toggle = true;
      this.confirmationDialogList[0].rightButtons[1].text = "Rename";
    },
    deleteRow(data) {
      this.resetDialogField();
      this.userInputText.isHide = true;
      this.userInputText.id = DialogAction.Delete;
      this.userInputText.payload = data;

      this.confirmationDialogList[0].title =
        "Delete " +
        data.description.replaceAll("<", "&lt;").replaceAll(">", "&gt;");
      this.confirmationDialogList[0].toggle = true;
      this.confirmationDialogList[0].rightButtons[1].text = "Delete";
    },

    submit_Click() {
      if (this.userInputText.id == DialogAction.Delete) {
        this.deleteSuperannuation(
          this.userInputText.payload.superFundGuid,
          this.userInputText.payload.description,
          this.getAuthInformation.encClientId
        );
      } else if (
        this.userInputText.id == DialogAction.Duplicate &&
        this.validateUserInput()
      ) {
        this.copySuperannuation(
          this.userInputText.payload.superFundGuid,
          this.userInputText.value
        );
      } else if (
        this.userInputText.id == DialogAction.Rename &&
        this.validateUserInput()
      ) {
        this.renameSuperannuation(
          this.userInputText.payload.superFundGuid,
          this.userInputText.value,
          this.getAuthInformation.encClientId
        );
      }
    },
    // Copy Superannuation
    async copySuperannuation(superFundGuid, description) {
      let selectedSuperannuation = Object.assign(
        {},
        this.getSuperannuationInformation.filter(
          (sr) => sr.superFundGuid == superFundGuid
        )[0]
      );
      selectedSuperannuation.description = description;
      let superannuationModel = this.createSaveSuperannuationModel(
        selectedSuperannuation
      );
      superannuationModel.s3FilePath = selectedSuperannuation.s3FilePath;
      this.setLoaderVisibility(true);
      let response = await SuperannuationService.createCopyOfSuperannuation(
        superannuationModel
      );
      this.setLoaderVisibility(false);
      if (response && response.status == 200) {
        this.setNotificationMessage(
          "success",
          `Superannuation instance ${description} has been added.`
        );
        let apiResponse = [];
        response.data.lastModifiedDateTime = new Date()
          .toISOString()
          .slice(0, 10);
        apiResponse.push(response.data);
        let copySuperannuation = Superannuation.setSuperannuationInformation(
          apiResponse,
          this.clientInformation
        );
        this.getSuperannuationInformation.splice(0, 0, copySuperannuation[0]);
        this.setAllSuperannuationInformation(this.getSuperannuationInformation);
        this.mapData();
        this.saveUserSession(SuperSelected, DuplicateAction, "");
      } else {
        this.setNotificationMessage(
          "error",
          `Failed to create copy of the ${description} instance .`
        );
      }
    },
    // Rename Superannuation
    async renameSuperannuation(superFundGuid, description, encClientId) {
      let fieldInfo = {
        ID: superFundGuid,
        Value: description,
        encClientId: encClientId,
      };
      this.setLoaderVisibility(true);
      let response = await SuperannuationService.updateSuperannuation(
        fieldInfo
      );
      this.setLoaderVisibility(false);
      if (response && response.status == 200) {
        this.setNotificationMessage(
          "success",
          `Superannuation instance ${description} has been updated.`
        );
        let selectedSuperannuationIndex =
          this.getSuperannuationInformation.findIndex(
            (sr) => sr.superFundGuid == superFundGuid
          );
        this.getSuperannuationInformation[
          selectedSuperannuationIndex
        ].description = description;
        this.getSuperannuationInformation[
          selectedSuperannuationIndex
        ].superannuationName = description;
        this.getSuperannuationInformation[
          selectedSuperannuationIndex
        ].modifiedDate = new Date().toISOString().slice(0, 10);
        this.getSuperannuationInformation.splice(
          0,
          0,
          this.getSuperannuationInformation[selectedSuperannuationIndex]
        );
        this.getSuperannuationInformation.splice(
          selectedSuperannuationIndex + 1,
          1
        );
        this.setAllSuperannuationInformation(this.getSuperannuationInformation);
        this.mapData();
        this.saveUserSession(SuperSelected, RenameAction, "");
      } else {
        this.setNotificationMessage(
          "error",
          `Failed to rename the ${description} instance .`
        );
      }
    },

    // Delete Superannuation
    async deleteSuperannuation(superFundGuid, description, encClientId) {
      this.setLoaderVisibility(true);
      let response = await SuperannuationService.deleteSuperannuation(
        superFundGuid,
        encClientId
      );
      this.setLoaderVisibility(false);
      if (response && response.status == 200) {
        this.setNotificationMessage(
          "success",
          `Superannuation instance ${description} has been deleted.`
        );
        let selectedSuperannuationIndex =
          this.getSuperannuationInformation.findIndex(
            (sr) => sr.superFundGuid == superFundGuid
          );
        this.getSuperannuationInformation.splice(
          selectedSuperannuationIndex,
          1
        );
        this.setLoaderVisibility(true);
        this.setAllSuperannuationInformation(this.getSuperannuationInformation);
        this.setLoaderVisibility(false);
        this.mapData();
        this.saveUserSession(SuperSelected, DeleteAction, "");
      } else {
        this.setNotificationMessage(
          "error",
          `Failed to delete the ${description} instance .`
        );
      }
    },

    createNewSuperannuation() {
      this.openBasicSuperannuationForm();
    },
    createSaveSuperannuationModel(selectedSuperannuation) {
      let superannuationModel = {};

      // data properties
      superannuationModel.clientId = selectedSuperannuation.clientId;
      superannuationModel.clientName = selectedSuperannuation.clientName;
      superannuationModel.superFundId = 0;
      superannuationModel.superannuationName =
        selectedSuperannuation.description;
      superannuationModel.fundDetails = selectedSuperannuation.fundDetails;
      superannuationModel.nonSuperData = selectedSuperannuation.nonSuperData;
      superannuationModel.ownerDetails = selectedSuperannuation.ownerDetails;
      superannuationModel.otherDetail = selectedSuperannuation.otherDetail;
      superannuationModel.ownerEntityType =
        selectedSuperannuation.ownerEntityType;
      superannuationModel.superFundGuid = selectedSuperannuation.superFundGuid;
      superannuationModel.superAdvanceDetails =
        selectedSuperannuation.superAdvanceDetails;
      superannuationModel.superAddtionalDetails =
        selectedSuperannuation.superAddtionalDetails;
      superannuationModel.parentSuperGuid =
        selectedSuperannuation.parentSuperGuid;
      superannuationModel.projectionYear =
        selectedSuperannuation.projectionYear;
      return superannuationModel;
    },
    openBasicSuperannuationForm() {
      let parentClientIndex = this.clientInformation.findIndex(
        (sr) => sr.entityType == 1
      );
      if (parentClientIndex >= 0) {
        let superannuationModel = Superannuation.getEmptySuperannuationModel(
          this.clientInformation[parentClientIndex]
        );
        this.getSuperannuationInformation.splice(0, 0, superannuationModel);
        this.setSuperannuationDefaultModel(this.getSuperannuationInformation);
        this.setSelectedSuperannuationInfo(
          Object.assign({}, superannuationModel)
        );
        this.saveUserSession(SuperSelected, tabCreatedAction, CompareAction);
        this.$router.push({ name: "superannuation-engagement-tool" });
      }
    },
    removeEmptySuperannuationInfo() {
      if (this.getSuperannuationInformation) {
        for (let i = 0; i < this.getSuperannuationInformation.length; i++) {
          if (
            this.getSuperannuationInformation[i] &&
            this.getSuperannuationInformation[i].superFundGuid ==
              "00000000-0000-0000-0000-000000000000"
          )
            this.getSuperannuationInformation.splice(i, 1);
        }
      }
    },
    compareSelectedSuperannuations(data) {
      let userSelectedSuperannuations = [];
      for (let i = 0; i < data.length; i++) {
        let selectedSuperannuations = this.getSuperannuationInformation.filter(
          (sr) => sr.superFundGuid == data[i].superFundGuid
        );
        userSelectedSuperannuations.push(selectedSuperannuations[0]);
      }
      this.setSuperannuationDefaultModel();
      this.setCompareSuperannuationInfo(userSelectedSuperannuations);
      this.saveUserSession(
        SuperSelected,
        CompareAction,
        userSelectedSuperannuations.length + ""
      );
      this.$router.push({ name: "compare-super" });
    },
    onSelectedSuperannuation(rowData) {
      const selectedSuperannuationInfo =
        this.getSuperannuationInformation.filter(
          (sr) => sr.superFundGuid == rowData.superFundGuid
        );
      if (selectedSuperannuationInfo && selectedSuperannuationInfo.length > 0) {
        selectedSuperannuationInfo[0].riskProfileId = rowData.riskProfileId;
        selectedSuperannuationInfo[0].incomeRate = rowData.incomeRate;
        selectedSuperannuationInfo[0].growthRate = rowData.growthRate;
        selectedSuperannuationInfo[0].description = rowData.description;
        selectedSuperannuationInfo[0].frankingRate = rowData.frankedRate;
        let superannuationModel = _.cloneDeep(selectedSuperannuationInfo[0]);
        // let superannuationModel = Object.assign(
        //   {},
        //   selectedSuperannuationInfo[0]
        // );
        this.setSuperannuationDefaultModel();
        this.setSelectedSuperannuationInfo(superannuationModel);

        this.saveUserSession(
          SuperSelected,
          tabSelectedAction,
          selectedSuperannuationInfo[0].isFromFact ? "FactFind" : ""
        );
        this.$router.push({ name: "superannuation-engagement-tool" });
      }
    },
    // Generic Methods
    setNotificationMessage(variation, message) {
      this.setNotificationSummary({
        isShow: true,
        variation: variation,
        text: message,
      });
    },
    validateUserInput() {
      let inputText = this.userInputText.value;
      if (!inputText) {
        return this.setErrorMessage();
      }
      let index = this.rows.findIndex(
        (sr) =>
          sr.description.toLowerCase() == this.userInputText.value.toLowerCase()
      );
      if (index >= 0) {
        return this.setErrorMessage(
          "The instance name is already taken, Use a different name to continue."
        );
      }
      return true;
    },
    setErrorMessage(errorText) {
      this.userInputText.isError = true;
      this.userInputText.errorText = [];
      this.userInputText.errorText.push(errorText);
      this.confirmationDialogList[0].toggle = true;
      return false;
    },
    cancel_Click() {
      this.confirmationDialogList[0].toggle = false;
    },
    genericMethodClick(function_name) {
      this[function_name]();
    },
    selectfilteredMenu(data) {
      this.selectedValue = data.value;
    },
    GetMenuObject(value, active, text) {
      return {
        value: value,
        active: value == active,
        text: text,
      };
    },
  },
  computed: {
    userEnterCharCount() {
      if (!this.userInputText.value) {
        return 0;
      } else {
        var spaceCount = this.userInputText.value.match(/^\s*/)[0].length;
        spaceCount = spaceCount < 0 ? 0 : spaceCount;
        if (this.userInputText.value.length > this.maxValue) {
          return this.maxValue;
        } else {
          return this.userInputText.value.length - spaceCount;
        }
      }
    },
    imagepath() {
      return require("../../assets/icons/Search.svg");
    },
    ...mapGetters({
      getAuthInformation: GET_AUTH_INFORMATION,
      clientInformation: GET_CLIENT_INFORMATION,
      loginUserInfo: GET_AUTH_INFORMATION,
    }),
    ...mapGetters("superannuation", {
      getSuperannuationInformation: GET_SUPERANNUATION_INFORMATION,
    }),

    // Right Panel
    getSuperRowsData() {
      return this.rows;
    },
    // Left Panel
    superCategories() {
      let menudata = [];
      if (this.rows.length == 0 || this.rows.length == undefined)
        return menudata;
      menudata.push(this.GetMenuObject("", this.selectedValue, "Recent"));
      return menudata;
    },
  },
  async created() {
    this.setAllSuperannuationInformation([]);
    this.removeEmptySuperannuationInfo();
    await this.mapData();
  },
};
</script>
<style></style>
